import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { SiteMeta } from './SiteMeta';
export function Layout() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="flex min-h-screen w-full flex-col bg-canvas" data-id="element-656" data-mp="uzcnwa2v1ocn">
      <SiteMeta data-id="element-657" data-mp="78gy1ihyt381" />
      <Header data-id="element-658" data-mp="77xho67yqmw4" />
      <main className="flex-1" data-id="element-659" data-mp="79ibftmge1sx">
        <Outlet data-id="element-660" data-mp="76mdw6eipf50" />
      </main>
      <Footer data-id="element-661" data-mp="29vyllajenkn" />
    </div>;
}